import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class NivelTecnologicoValidation extends DefaultValidation {

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        if (Util.isNull(model.idempresa)) {
            refs.empresaSelect.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idcultura)) {
            refs.culturaSelect.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}